/*******************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2025 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ******************************************************************************/
import { ITimeUpdater } from "utilities/TimeUpdater/ITimeUpdater";

export class TimeoutTimeUpdater implements ITimeUpdater {
  private _timeoutId: NodeJS.Timeout | undefined;
  private _callback: VoidFunction | undefined;

  resume(): void {
    if (this._callback !== undefined) {
      this._timeoutId = setInterval(this._callback, 32); // 30 fps
    }
  }

  suspend(): void {
    clearInterval(this._timeoutId);
  }

  schedule(callback: VoidFunction): void {
    this._callback = callback;
  }
}
